import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageTransition from '../components/PageTransition';
import { COMMITTEES, COMMITTEES_PAGE } from '../data';
import './CommitteesPage.css';

export default function CommitteesPage() {
  const [filter, setFilter] = useState('Tümü');
  const d = COMMITTEES_PAGE;

  const filtered = filter === 'Tümü'
    ? COMMITTEES
    : COMMITTEES.filter(c => c.difficulty === filter);

  return (
    <PageTransition>
      <div className="committees-page">

        <section className="page-hero">
          <div className="page-hero-bg" />
          <div className="container page-hero-content">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
              <span className="section-tag">{d.hero.tag}</span>
              <h1>{d.hero.title}</h1>
              <p>{d.hero.description}</p>
            </motion.div>
          </div>
        </section>

        <section className="committees-main">
          <div className="container">
            <div className="committees-filter">
              <span className="filter-label">{d.filterLabel}</span>
              <div className="filter-buttons">
                {d.difficulties.map(diff => (
                  <button
                    key={diff}
                    className={`filter-btn ${filter === diff ? 'active' : ''}`}
                    onClick={() => setFilter(diff)}
                  >
                    {diff}
                  </button>
                ))}
              </div>
            </div>

            <div className="committees-grid">
              {filtered.map((c, i) => (
                <motion.div
                  key={c.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.07 }}
                >
                  <Link to={`/komiteler/${c.slug}`} className="committee-card">
                    <div className="committee-card-top" style={{ borderTopColor: c.color, background: `linear-gradient(135deg, ${c.color}18, ${c.color}06)` }}>
                      <span className="committee-card-icon-big">{c.icon}</span>
                      <div className="committee-card-badges">
                        <span className={`difficulty difficulty-${c.difficulty === 'Başlangıç' ? 'easy' : c.difficulty === 'Orta' ? 'medium' : 'hard'}`}>{c.difficulty}</span>
                        <span className="delegate-badge">{c.delegate_count} Kontenjan</span>
                      </div>
                    </div>
                    <div className="committee-card-body">
                      <h2>{c.title}</h2>
                      <p className="committee-subtitle">{c.subtitle}</p>
                      <p className="committee-desc">{c.description}</p>
                      <div className="committee-topics-preview">
                        <span className="topics-label">Tartışma Konuları</span>
                        <ul>
                          {c.topics.slice(0, 3).map(t => <li key={t}>{t}</li>)}
                          {c.topics.length > 3 && <li className="topics-more">+{c.topics.length - 3} konu daha</li>}
                        </ul>
                      </div>
                      <div className="committee-card-footer">
                        <span className="moderator-count">{c.moderators.length} Moderatör</span>
                        <span className="committee-detail-link">Detaylar →</span>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

      </div>
    </PageTransition>
  );
}
